import React from 'react';
import { CheckCircle2, Sparkles, BookOpen, BookOpenCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface LessonCardProps {
  id: string;
  title: string;
  description: string;
  completed: boolean;
  highScore?: number;
}

const LessonCard: React.FC<LessonCardProps> = ({ id, title, description, completed, highScore = null}) => {
  const navigate = useNavigate();

  return (
    <div onClick={() => navigate(`/lessons/${id}`)} className="w-[330px] rounded-xl bg-bg-panel bg-opacity-90 backdrop-blur-sm border border-white/10 shadow-[0_0_10px_rgba(79,255,222,0.1)] hover:scale-[1.05] transition-transform duration-200 cursor-pointer hover:bg-cyan-500/20 p-6">
      <h3 className="text-xl font-semibold text-primary flex items-center gap-2 mb-1">{completed ? <BookOpenCheck className="w-5 h-5" /> : <BookOpen className="w-5 h-5" />}{title}</h3>
      <p className="text-sm text-white-600 mt-2">{description}</p>

      <div className="mt-4 flex justify-between items-center">
          {id !== "none" && (
          <>
            {completed && (<div className="flex items-center gap-2 mb-1">
              <CheckCircle2 className="w-4 h-4 text-green-400" />
              <span className="text-sm text-green-400">Completed ({highScore?.toFixed(1)})</span>
            </div>)}

            {!completed && (<div className="flex items-center gap-2 mb-1">
              <Sparkles className="w-4 h-4 text-yellow-400" />
              <span className="text-sm text-yellow-400">Available</span>
            </div>)}
          </>
          )}
      </div>
    </div>
  );
};

export default LessonCard;